import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Post, PostCommentTree} from '../../_types/content';

@Component({
    selector: 'app-comments-list',
    templateUrl: './comments-list.component.html',
    styleUrl: './comments-list.component.scss'
})
export class CommentsListComponent implements OnChanges {
    @Input({required: true}) comments: PostCommentTree[] = [];
    @Input({required: true}) post!: Post;
    @Input() onlyPinned: boolean = false;
    @Input() child: boolean = false;

    constructor(private readonly cdr: ChangeDetectorRef) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['comments']?.currentValue) {
            this.cdr.detectChanges();
        }
    }
}
